import React from "react";
import {Link} from "react-router-dom";
import {Objects, Types} from "components";
import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {TextField} from "@material-ui/core";

function liBool(v) {
	if (v === true || v === 1 || v === '1' || v === 'true') return true;
	if (v === false || v === 0 || v === '0' || v === 'false') return false;
	return !!v;
}

// noinspection JSUnresolvedVariable
export default ({
	                entry = null,
	                product = null,
	                onDelete,
	                onUpdate,
	                modalUpdate,
	                openModal,
	                handleTaxableChange,
	                history,
                }) => {
	const taxable = (() => {
		if (entry?.taxable !== undefined && entry?.taxable !== null && entry.taxable !== '') {
			return liBool(entry.taxable);
		}
		const inf = entry?.information ?? product;
		if (inf?.taxable !== undefined && inf?.taxable !== null && inf.taxable !== '') {
			return liBool(inf.taxable);
		}
		const sku = inf?.skus ?? inf?.Skus;
		if (sku?.taxable !== undefined && sku?.taxable !== null && sku.taxable !== '') {
			return liBool(sku.taxable);
		}
		return true;
	})();

	const unitPrice = entry?.price ?? entry?.cost ?? product?.skus?.price_retail ?? product?.price;
	const displayName = entry?.name ?? product?.skus?.name ?? product?.name ?? 'N/A';
	const displayQty = entry?.quantity ?? product?.quantity;

	return (
		<div key={Math.random()} className="portlet box blue-hoki">
			<div className="portlet-title">
				<div className="caption">
					<i className="fa fa-barcode"/>&nbsp;&nbsp;
					{displayName}
					{unitPrice != null && unitPrice !== '' ? (
						<> - ${parseFloat(unitPrice).toFixed(2)}</>
					) : null}
					<span>&nbsp;&nbsp;x&nbsp;&nbsp;</span>
					{displayQty}
				</div>
				{onDelete && <div className="tools">
					<a href='#'
					   onClick={() => onDelete()}
					   className="remove"
					   style={{color: 'white'}}><i className={"fa fa-remove"}/></a>
				</div>}
			</div>
			<div className="portlet-body" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>

				<div style={{display: 'flex', flexDirection: 'column'}}>
					<h5 style={{marginTop: 0, alignSelf: 'flex-start'}}>${entry.price ?? entry.cost ?? product.skus?.price_retail} {(parseFloat(entry?.discount_amount) > 0 || parseFloat(product?.discount_amount) > 0) && <b style={{color: 'red'}}>(-${entry.discount_amount ?? product.discount_amount})</b>}</h5>
					<h5 style={{marginTop: 0, alignSelf: 'flex-start'}}>SKU: {entry.sku ?? product?.skus?.sku ?? ''}</h5>
				</div>
				<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignSelf: 'flex-end'}}>
					<ButtonGroup
						style={{marginRight: '10px'}}
					>
						<Button
							id={'true'}
							color="primary"
							outline={!!taxable === false}
							active={!!taxable === true}
							className="primary-button-buttongroup"
							onClick={() => handleTaxableChange(true)}
						>
							Taxable
						</Button>
						<Button
							id={'false'}
							color="primary"
							outline={!!taxable === true}
							active={!!taxable === false}
							className="primary-button-buttongroup"
							onClick={() => handleTaxableChange(false)}
						>
							Non-Taxable
						</Button>
					</ButtonGroup>
					<a onClick={openModal} className="btn btn-sm blue-hoki">Edit</a>
				</div>
			</div>
		</div>
	)
};
